import { create } from 'zustand'

export type SettingsSection =
  | 'general'
  | 'account'
  | 'restaurant'
  | 'integrations'

/** Where the venue's Google place is set, inside the restaurant section. */
export const GOOGLE_LOCATION_ANCHOR = 'settings-google-location'

interface SettingsModalState {
  /** The section on screen, or null while the modal is closed. */
  section: SettingsSection | null
  /** A block to bring into view once the section is open. */
  anchor: string | null
  open: (section?: SettingsSection, anchor?: string) => void
  close: () => void
}

/**
 * A store rather than local state because more than one place opens the
 * modal, the account menu and the venue facts on the website template, and
 * each wants it on a different section.
 */
export const useSettingsModal = create<SettingsModalState>(set => ({
  section: null,
  anchor: null,
  open: (section = 'general', anchor) =>
    set({ section, anchor: anchor ?? null }),
  close: () => set({ section: null, anchor: null })
}))
